import { Link } from 'react-router-dom';
import { editorPick } from '@/mocks/comics';

export default function EditorPick() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="relative bg-foreground-950 rounded-3xl overflow-visible">
          <div className="flex flex-col md:flex-row">
            {/* Left: Cover image - overlaps left edge */}
            <div className="relative md:w-[40%] lg:w-[35%] shrink-0">
              <div className="relative h-[350px] md:h-full md:absolute md:inset-y-0 md:-left-8 md:w-[120%]">
                <img
                  src={editorPick.cover}
                  alt={editorPick.title}
                  title={editorPick.title}
                  className="w-full h-full object-cover object-top rounded-2xl md:rounded-2xl"
                />
              </div>
            </div>

            {/* Right: Content */}
            <div className="relative z-10 p-6 md:p-10 lg:p-14 md:w-[60%] lg:w-[65%] flex flex-col justify-center">
              {/* Decorative quote mark */}
              <span className="text-7xl md:text-8xl text-accent-300/20 font-serif leading-none select-none">
                &ldquo;
              </span>

              {/* Tagline */}
              <p className="text-xs md:text-sm text-accent-400 font-medium tracking-widest uppercase -mt-4 mb-4">
                {editorPick.tagline}
              </p>

              {/* Recommendation text */}
              <p className="text-base md:text-lg lg:text-xl text-background-50/90 leading-relaxed max-w-xl font-light">
                {editorPick.description}
              </p>

              {/* Editor info */}
              <div className="mt-6 md:mt-8">
                <p className="text-sm text-background-50 font-medium">
                  {editorPick.editorName}
                </p>
                <p className="text-xs text-background-50/50 mt-1">
                  {editorPick.editorTitle}
                </p>
              </div>

              {/* CTA */}
              <div className="mt-6 md:mt-8">
                <Link
                  to={`/comic/${editorPick.id}`}
                  className="inline-flex items-center gap-2 px-7 py-3 bg-accent-500/90 text-background-50 rounded-full text-sm font-medium hover:bg-accent-500 transition-all whitespace-nowrap cursor-pointer"
                >
                  立即阅读
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}